var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "90,13 90,3 84,3 84,13 74,13 74,19 84,19 84,29 90,29 90,19 100,19 100,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "36,75 36,26 30,26 21.4,34.6 25.7,38.8 30,34.5 30,75  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.3,38c1.1,3.8,1.7,7.8,1.7,12c0,24.3-19.7,44-44,44S6,74.3,6,50S25.7,6,50,6 c5.3,0,10.3,0.9,15,2.6V2.3C60.3,0.8,55.2,0,50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50c0-4.1-0.5-8.2-1.5-12H92.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M77,39c0-7.2-6.7-13-15-13s-15,5.8-15,13c0,4,2.1,7.6,5.4,10c-3.9,2.6-6.4,6.8-6.4,11.5 c0,8,7.2,14.5,16,14.5s16-6.5,16-14.5c0-4.7-2.5-8.9-6.4-11.5C74.9,46.6,77,43,77,39z M72,60.5c0,4.7-4.5,8.5-10,8.5 s-10-3.8-10-8.5S56.5,52,62,52S72,55.8,72,60.5z M53,39c0-3.8,4.1-7,9-7s9,3.2,9,7s-4.1,7-9,7S53,42.8,53,39z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18+.b19100856f12d09228b7f661f9d91423.svg";
export { ForwardRef as ReactComponent };